import { IInferenceModel, SubscriptionTiers, useModelTierDisplayName } from "@next-platform/client-common-core";
import {
  Badge,
  BadgeSize,
  BadgeVariant,
  Button,
  ButtonVariant,
  Icon,
  IconSize,
  IconVariants,
  Text,
  TextVariants,
} from "@next-platform/client-common-spicy-ui";

import { Col, Row } from "@/components";
import Trans from "@/components/Trans/Trans";
import { cn, getTierBadgeColors } from "@/utils";

const ModelSelectionItem = ({
  model,
  isLocked,
  action,
  activeModel,
  clickHandler,
}: {
  model: IInferenceModel;
  isLocked?: boolean;
  activeModel?: string | null;
  action?: () => void;
  clickHandler?: ({ id, name }: { id: string; name: string }) => void;
}) => {
  const { id, name, tag, level, description } = model;
  const tierDisplayName = useModelTierDisplayName({ level });
  const isDisabled = !isLocked && model.isDisabled;
  const handleClick = () => {
    if (isDisabled) {
      return;
    }
    if (action) {
      action();
    } else if (clickHandler) {
      clickHandler({ id, name });
    }
  };

  return (
    <Row
      className={cn("items-center px-[18px] py-[10px] gap-[18px] cursor-pointer hover:bg-gray-7", isDisabled ? "opacity-50 cursor-not-allowed" : "")}
      onClick={handleClick}
    >
      <Col className="gap-[2px]">
        <Row className="items-center gap-1 flex-wrap">
          <Text variant={TextVariants.LABEL_LARGE_REGULAR}>{name}</Text>
          {level || tag ? (
            <Row className="items-center gap-sm">
              {level ? (
                <Badge
                  size={BadgeSize.DEFAULT}
                  className={cn(getTierBadgeColors(level as SubscriptionTiers))}
                  showDot={false}
                  variant={BadgeVariant.COLORED}
                >
                  {tierDisplayName}
                </Badge>
              ) : null}
              {tag ? (
                <Badge showDot={false} variant={BadgeVariant.OUTLINED}>
                  {tag}
                </Badge>
              ) : null}
            </Row>
          ) : null}
        </Row>
        <Row>
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className={`text-gray-10 line-clamp-2 `}>
            {description}
          </Text>
        </Row>
      </Col>
      {!!(activeModel && id === activeModel) && <Icon icon={IconVariants.CHECK} size={IconSize.MEDIUM} className="text-blue-10" />}
      {!!action && <Icon icon={IconVariants.CHEVRON_RIGHT} size={IconSize.MEDIUM} className="text-gray-12" />}
      {!!isLocked && (
        <Button variant={ButtonVariant.OUTLINED}>
          <Trans i18nKey="chat:page.header.modelSelection.dropdown.upgrade.button" />
        </Button>
      )}
    </Row>
  );
};

export default ModelSelectionItem;
